import React from "react";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";

import styles from "./styles.module.scss";
import {
  getPriceAndRewardsCopy,
  getPriceRewardTitles,
  MAX_TRAVELER_TEXT,
  PRICE_VARIES_ON_GROUP_SIZE,
} from "../../textConstants";
import { IShopCheckoutBreakdownProps } from "../ShopCheckoutBreakdown/component";

export const ShopCheckoutBreakdownSummary = (
  props: IShopCheckoutBreakdownProps
) => {
  const {
    priceBreakdown,
    parsedAgeBands,
    experienceMaxTravelers,
    largestValueAccount,
    pricingCategory,
  } = props;

  const { priceTitle, rewardsTitle } = getPriceRewardTitles(
    priceBreakdown,
    parsedAgeBands,
    pricingCategory,
    largestValueAccount
  );

  let subtitle = experienceMaxTravelers
    ? MAX_TRAVELER_TEXT(experienceMaxTravelers)
    : undefined;

  if (
    parsedAgeBands?.Adult?.priceVariesByCount ||
    parsedAgeBands?.Traveler?.priceVariesByCount
  ) {
    subtitle = PRICE_VARIES_ON_GROUP_SIZE;
  }

  return (
    <Box
      className={clsx(
        styles["experiences-shop-checkout-breakdown-summary"],
        "experiences-shop-checkout-breakdown-summary"
      )}
    >
      <Typography
        className={styles["experiences-shop-checkout-breakdown-title"]}
        dangerouslySetInnerHTML={{
          __html: getPriceAndRewardsCopy({
            price: priceTitle,
            rewards: rewardsTitle,
          }),
        }}
      />
      {subtitle && (
        <Typography
          className={styles["experiences-shop-checkout-breakdown-subtitle"]}
          variant="body2"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
